const clearFilterButtonManagementEquip = {
  Typography: 'Clear'
};

export default clearFilterButtonManagementEquip;
